import React from 'react';
import { ArrowRight } from 'lucide-react';

export function Hero() {
  const scrollToStartHere = () => {
    if (typeof document === "undefined") return;
    const el = document.getElementById("start-here");
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <div className="relative pt-40 pb-6 md:pt-46 md:pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-4 pb-2">
        <div className="text-center relative">
          <h1 className="text-4xl md:text-6xl font-bold text-white mb-6 leading-tight">
            More Clients.
            Less Busywork.
          </h1>
          <p className="text-xl md:text-2xl text-gray-300 mb-6 max-w-4xl mx-auto leading-relaxed">
            I help hands-on health clinics get better clients and stop leaking leads with simple marketing, smart follow-up, and light automation built around the systems you already use.
          </p>
          <div className="flex justify-center mb-8">
            <button
              onClick={scrollToStartHere}
              className="inline-flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-green-500 to-blue-500 text-white font-bold rounded-md hover:from-green-600 hover:to-blue-600 transition-all duration-300 shadow-lg hover:shadow-xl"
            >
              Start Here
              <ArrowRight className="w-5 h-5" />
            </button>
          </div>
        </div>
      </div>

      {/* Decorative elements */}
      <div className="absolute -top-40 -right-40 w-80 h-80 bg-blue-500/10 rounded-full blur-3xl" />
      <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-blue-500/10 rounded-full blur-3xl" />
    </div>
  );
}